import React, { useEffect, useState } from 'react';
import { postDataPages } from '../../../service/learningService';
import { Tlearning } from '../../../type/learning';
import LearningItemVertical from './LearningItemVertical';

const LearningGrid = () => {
	const [learning, setLearning] = useState<Tlearning[]>([]);

	const getDataCategory = async () => {
		const data = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'name',
					value: '',
					operation: 'MATCH',
					conjunction: 'and',
				},
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: 'and',
				},
			],
		};
		const response = await postDataPages(data);
		if (!response?.error) {
			setLearning(response?.data.content);
		}
	};

	useEffect(() => {
		getDataCategory();
	}, []);

	return (
		<>
			<div className="grid grid-cols-2 gap-4">
				{learning.map((item: Tlearning, index: number) => {
					return (
						<>
							<LearningItemVertical
								learning={item}
								key={index}
							/>
						</>
					);
				})}
			</div>
		</>
	);
};

export default LearningGrid;
